/**
 * Reactive language state. Kept in its own `.svelte.ts` module so the rune compiles;
 * `$lib/i18n` re-exports the accessors. The value is read once from `localStorage["tik.lang"]`
 * (default `"ar"`) — changing it reloads the page, exactly as the legacy app did, so nothing
 * else in the app needs to react to it at runtime.
 */
export type Lang = 'ar' | 'en';

export const LANG_KEY = 'tik.lang';

function readStoredLang(): Lang {
  try {
    const v = typeof localStorage !== 'undefined' ? localStorage.getItem(LANG_KEY) : null;
    return v === 'en' ? 'en' : 'ar';
  } catch {
    return 'ar';
  }
}

class LangState {
  current = $state<Lang>(readStoredLang());

  /** Text direction derived from the language: Arabic is RTL, anything else LTR. */
  get dir(): 'rtl' | 'ltr' {
    return this.current === 'ar' ? 'rtl' : 'ltr';
  }

  /** Re-read the stored value (used by tests after touching localStorage). */
  reload(): void {
    this.current = readStoredLang();
  }
}

export const langState = new LangState();
